import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject, throwError } from "rxjs";
import { tap, catchError, map } from "rxjs/operators";

interface UserData {
  email: string;
  // Add more fields later maybe
}

interface MenuResponse {
  user: UserData;
  menu: any[];
}

@Injectable({
  providedIn: "root",
})
export class MenuService {
  private menuData$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private userData$: BehaviorSubject<UserData> = new BehaviorSubject<UserData>({
    email: "",
  });

  constructor(private http: HttpClient) {
    this.fetchMenuData().subscribe({ error: () => {} });
  }

  getMenuData(): Observable<any[]> {
    return this.menuData$.asObservable();
  }

  getUserEmail(): Observable<string> {
    return this.userData$.asObservable().pipe(
      // Transform the user object to just the email string
      tap((user) => {
        if (!user.email) console.warn("User email is empty");
      }),
      // Use map to extract only the email string
      map((user) => user.email),
    );
  }

  getUserData(): Observable<UserData> {
    return this.userData$.asObservable();
  }

  public fetchMenuData(): Observable<void> {
    // Menus are authorization data. Fail closed until the current session's
    // server-filtered menu arrives instead of hydrating a previous user's cache.
    this.menuData$.next([]);
    this.userData$.next({ email: "" });
    localStorage.removeItem("menuData");

    return this.http.get<MenuResponse>("/api/menu_handler.php").pipe(
      catchError((error) => {
        console.error("Failed to fetch menu:", error);
        return throwError(error);
      }),
      tap((data) => {
        this.menuData$.next(data.menu);
        this.userData$.next(data.user);
      }),
      map(() => {}), // Ensures it returns Observable<void>
    );
  }
}
